export { DefaultSpacing } from '@fluentui/theme';
